// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1AmQV","inputDescription":"styles_inputDescription__2czwv"};